import { render } from "./Typeahead.vue?vue&type=template&id=5057d544&scoped=true&ts=true"
import script from "./Typeahead.vue?vue&type=script&lang=ts"
export * from "./Typeahead.vue?vue&type=script&lang=ts"

import "./Typeahead.vue?vue&type=style&index=0&id=5057d544&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5057d544"]])

export default __exports__